// Use plural names to match the `Temporal.Duration` web standard.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/Duration#instance_properties

export const milliseconds = 1;
export const seconds = 1000 * milliseconds;
export const minutes = 60 * seconds;
export const hours = 60 * minutes;
export const days = 24 * hours;